import {useEffect} from 'react';
import {Outlet} from 'react-router-dom';
import {environments} from '../../configs';
import {useChekinSDK} from '../../context/ChekinSDK';
import {useReservation} from '../../context/reservation';
import ErrorView from '../../pages/ErrorView';
import {SDKErrorView} from '../../pages/SDKErrorView';
import ChekinProSettings from 'ChekinProSettings';

const IS_SDK_MODE = environments.VITE_APP_IS_SDK;

function ConnectionErrorsHandler() {
  const {isAuthInitializationError, hasToken: hasTokenInUrl, authError} = useChekinSDK();
  const {reservationError, isError: isReservationError} = useReservation();

  const hasAnyLoadingError = isAuthInitializationError || isReservationError;

  useEffect(() => {
    if (IS_SDK_MODE && hasAnyLoadingError) {
      ChekinProSettings.events.onConnectionError(
        authError || reservationError?.toString(),
      );
    }
  }, [
    authError,
    hasAnyLoadingError,
    isAuthInitializationError,
    isReservationError,
    reservationError,
  ]);

  if (IS_SDK_MODE && hasAnyLoadingError) {
    return <SDKErrorView text={authError || reservationError} />;
  }

  if (!IS_SDK_MODE && (!hasTokenInUrl || isAuthInitializationError)) {
    return <ErrorView />;
  }

  return <Outlet />;
}

export {ConnectionErrorsHandler};
